<template>
    <a-layout id="customer" class="page_layout">
        <a-layout-header class="page_header customer_header">
            <a-row type="flex" justify="space-between" align="middle" style="height: 64px">
                <a-form layout="inline" @keyup.enter.native="search">
                    <a-form-item label="" v-if="!showSearch">
                        <a-select v-model="selectType" @change="changeSelect" style="width:100px;margin-right: 10px;display: inline-block;">
                            <a-select-option value="1">
                                全部
                            </a-select-option>
                            <a-select-option value="2">
                                微信
                            </a-select-option>
                            <a-select-option value="3">
                                企业微信
                            </a-select-option>
                        </a-select>
                        <a-input
                            v-model="searchData.contactName"
                            placeholder="客户名称"
                            allowClear
                            @change="contactNameChange"
                            v-if="selectType === '2'"
                            style="display: inline-block;width: calc(100% - 110px);"
                        />
                        <a-input
                            v-model="searchData.keyWords"
                            placeholder="客户名称/公司名称"
                            allowClear
                            @change="contactNameChange"
                            v-else
                            style="display: inline-block;width: calc(100% - 110px);"
                        />
                    </a-form-item>
                    <a-form-item label="标签" v-if="!showSearch">
                        <a-button @click="toOpenTags" v-if="tagsValue.length === 0">
                            请选择
                        </a-button>
                        <a-select
                            mode="multiple"
                            v-model="tagsValue"
                            :open="false"
                            :max-tag-count="2"
                            placeholder="请选择"
                            label-in-value
                            allow-clear
                            v-else
                            @click.native="toOpenTags"
                            @change="tagsChange"
                        >
                            <a-select-option v-for="item in tagSelect" :key="item.tagId">
                                {{ item.tagName }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item v-if="!showSearch">
                        <a-button type="primary" @click="search">搜索</a-button>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="link" @click="showSearch = true">更多搜索条件</a-button>
                    </a-form-item>
                </a-form>
                <a-popconfirm
                    title="同步企业微信客户数据，一天同步一次"
                    placement="bottom"
                    ok-text="立即同步"
                    cancel-text="暂不同步"
                    @confirm="toSync"
                >
                    <a-button icon="sync">同步客户列表</a-button>
                </a-popconfirm>
            </a-row>
        </a-layout-header>
        <!-- 当前条件 -->
        <a-layout-header class="page_header customer_header" style="padding-bottom: 30px; height: auto;line-height: inherit;" v-if="currCondition && currCondition.length > 0">
            <a-space>
                筛选条件：
                <a-button size="small" v-for="(item, index) in currCondition" :key="index" @click.stop="tagClose(item)">
                    {{item.newName}}：{{(item.name === "userId" || item.name === "tagId") ? item.value + '个' : item.value}}
                    <a-icon type="close" style="transform: scale(0.7);" class="base_font_color_909399" />
                </a-button>
            </a-space>
        </a-layout-header>
        <a-layout-content class="page_content customer_content">
            <a-table
                :columns="columns"
                :data-source="dataList"
                :pagination="false"
                :loading="loading"
                :row-key="(record) => record.id"
                :row-selection="rowSelection"
                :class="[currCondition.length > 0 ? '' : 'active_bg']"
            >
                <template slot="name" slot-scope="text, record">
                    <div>
                         {{ record.name }}
                    </div>
                    <div :style="record.type === 1 ? 'color:#87d068;' : 'color:gold;'" class="base_font_size_12">
                        <a-icon
                            v-if="record.gender"
                            slot="count"
                            :type="record.gender === 1 ? 'man' : 'woman'"
                            :style="record.gender === 1 ? 'color:#86bcff;' : 'color:pink;'"
                        />
                        {{ record.type === 1 ? '@微信' : `@${record.corpName}` }}
                    </div>
                </template>
                <template slot="user" slot-scope="text, record">
                    <openData type="userName" :openid="record.userId"></openData>
                </template>
                <template slot="tag" slot-scope="text, record">
                    <a-space class="dir_left_wrap cross_center">
                        <a-tag
                            v-for="item in record.tag"
                            :key="item.tagId"
                            style="margin-bottom: 5px;"
                        >
                            {{ item.tagName }}
                        </a-tag>
                    </a-space>
                </template>
                <template slot="footer">
                    <div class="table_footer main_between cross_center">
                        <div>
                            <a-checkbox
                                style="margin-left:6px;margin-right: 35px;"
                                :indeterminate="indeterminate"
                                :checked="checkAll"
                                @change="onCheckAllChange"
                            ></a-checkbox>
                            <a-button @click="toOpen">
                                批量设置标签（已选客户：
                                <span class="base_font_color_ff5800">{{currCustomer.length}}</span>
                                ）
                            </a-button>
                        </div>
                        <a-pagination
                            v-model="searchData.page"
                            :total="pagination.total"
                            :pageSize="pagination.pageSize"
                            show-less-items
                            @change="tableChange"
                        />
                    </div>
                </template>
            </a-table>
        </a-layout-content>
        <contactsModal
            ref="contacts"
            :title="['选择添加成员', '已选择的添加成员']"
            type="batch"
            :selectKey="searchData.userId"
            @change="contactsChange"
        ></contactsModal>
        <tagModal ref="tags" :selectKey="tagSelect" @change="tagsChange"></tagModal>
        <a-modal
            title="搜索"
            :visible="showSearch"
            wrapClassName="contacts_search"
            :footer="null"
            @cancel="showSearch = false"
        >
            <a-form @keyup.enter.native="search">
                <a-form-item label="客户名称">
                    <a-select v-model="selectType" @change="changeSelect" style="width:100px;margin-right: 10px;display: inline-block;">
                        <a-select-option value="1">
                            全部
                        </a-select-option>
                        <a-select-option value="2">
                            微信
                        </a-select-option>
                        <a-select-option value="3">
                            企业微信
                        </a-select-option>
                    </a-select>
                    <a-input
                        v-model="searchData.contactName"
                        placeholder="客户名称"
                        allowClear
                        @change="contactNameChange"
                        v-if="selectType === '2'"
                        style="display: inline-block;width: calc(100% - 110px);"
                    />
                    <a-input
                        v-model="searchData.keyWords"
                        placeholder="客户名称/公司名称"
                        allowClear
                        @change="contactNameChange"
                        v-else
                        style="display: inline-block;width: calc(100% - 110px);"
                    />
                </a-form-item>
                <a-form-item label="标签">
                    <a-button @click="toOpenTags" v-if="tagsValue.length === 0"> 请选择 </a-button>
                    <a-select
                        mode="multiple"
                        v-model="tagsValue"
                        :open="false"
                        :max-tag-count="4"
                        placeholder="请选择"
                        label-in-value
                        allow-clear
                        v-else
                        @click.native="toOpenTags"
                        @change="tagsChange"
                    >
                        <a-select-option v-for="item in tagSelect" :key="item.tagId">
                            {{ item.tagName }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="添加成员">
                    <a-button @click="toOpenContacts" v-if="searchData.userId.length === 0">
                        请选择
                    </a-button>
                    <a-select
                        mode="multiple"
                        v-model="searchData.userId"
                        :open="false"
                        :max-tag-count="4"
                        placeholder="请选择"
                        allow-clear
                        v-else
                        @click.native="toOpenContacts"
                        @change="contactsChange"
                    >
                        <a-select-option v-for="item in searchData.userId" :key="item">
                            <openData type="userName" :openid="item"></openData>
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="添加时间">
                    <a-range-picker
                        v-model="dateTime"
                        allow-clear
                        @change="dateTimeChange"
                    ></a-range-picker>
                </a-form-item>
                <a-form-item label="性别">
                    <a-checkbox-group
                        v-model="genderArr"
                        :options="['男性', '女性']"
                        @change="checkboxChange"
                    />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="search">搜索</a-button>
                </a-form-item>
            </a-form>
        </a-modal>
        <customerDrawer
            ref="customerDrawer"
            :data="currCustomer"
            @backStatus="backStatus"
        ></customerDrawer>
    </a-layout>
</template>

<script>
import _ from 'lodash';
import api from '@/apis';
import openData from '@/components/group/openData';
import contactsModal from '@/components/group/contactsModal';
import tagModal from '@/components/group/tagModal';
import customerDrawer from '@/components/group/customerDrawer';
export default {
    components: {
        openData,
        contactsModal,
        tagModal,
        customerDrawer
    },
    data() {
        return {
            loading: false,
            showSearch: false,
            indeterminate: false,
            checkAll: false,
            dateTime: [],
            tagSelect: [],
            tagsValue: [],
            pagination: {
                total: 0,
                pageSize: 1
            },
            searchData: {
                page: 1,
                userId: [],
                tagId: [],
            },
            columns: [
                // {
                //     title: '客户',
                //     key: 'avatar',
                //     scopedSlots: { customRender: 'avatar' }
                // },
                {
                    title: '客户',
                    key: 'name',
                    scopedSlots: { customRender: 'name' }
                },
                {
                    title: '添加成员',
                    key: 'userId',
                    scopedSlots: { customRender: 'user' },
                    width: 100
                },
                {
                    title: '标签',
                    key: 'tag',
                    scopedSlots: { customRender: 'tag' }
                },
                {
                    title: '添加时间',
                    key: 'addTime',
                    width: 150,
                    dataIndex: 'addTime'
                }
            ],
            dataList: [],
            rowSelection: {
                onChange: (selectedRowKeys, selectedRows) => {
                    // console.log('onChange:', `selectedRowKeys: ${selectedRowKeys}`, selectedRows);
                    this.rowSelection.selectedRowKeys = selectedRowKeys;
                },
                onSelect: (record, selected, selectedRows) => {
                    // console.log('onSelect:', record, selected, selectedRows);
                    this.selectCustomer(selected, [record]);
                    this.checkAllStatus();
                },
                onSelectAll: (selected, selectedRows, changeRows) => {
                    // console.log('onSelectAll:', selected, selectedRows, changeRows);
                    this.selectCustomer(selected, changeRows);
                    this.checkAllStatus();
                },
                selectedRowKeys: []
            },
            // 当前客户信息
            currCustomer: [],
            selectType: '1',
            genderArr: [],
            currCondition: []
        };
    },
    watch: {},
    mounted() {
        this.init();
    },
    methods: {
        // 初始数据
        async init() {
            this.loading = true;
            try {
                const res = await api.getContact({ page: this.searchData.page });
                if (res.code !== 0) return;
                this.loading = false;
                this.pagination.total = res.count;
                this.pagination.pageSize = res.pageSize;
                this.dataList = res.rows;
            } catch (err) {
                console.log(err);
            }
        },
        // 搜索
        async search() {
            this.showSearch = false;
            this.loading = true;
            let data = {};
            data.page = this.searchData.page;
            if (this.searchData.contactName) data.contactName = this.searchData.contactName;
            if (this.searchData.keyWords) data.keyWords = this.searchData.keyWords;
            if (this.searchData.gender) data.gender = this.searchData.gender;
            if (this.searchData.tagId && this.searchData.tagId.length > 0) data.tagId = this.searchData.tagId;
            if (this.searchData.userId && this.searchData.userId.length > 0) data.userId = this.searchData.userId;
            if (this.searchData.startTime) data.startTime = this.searchData.startTime;
            if (this.searchData.endTime) data.endTime = this.searchData.endTime;
            if (this.selectType === '2') {
                data.type = 1;
                this.searchData.selectType = '2';
            } else if (this.selectType === '3') {
                data.type = 2;
                this.searchData.selectType = '3';
            } else {
                this.searchData.selectType = '1';
            }
            try {
                const res = await api.postContactSearch(data);
                if (res.code !== 0) return;
                this.loading = false;
                this.pagination.total = res.count;
                this.pagination.pageSize = res.pageSize;
                this.dataList = res.rows;
                this.genderArr = [];
                this.condition();
                // delete this.searchData.keyWords;
                // delete this.searchData.contactName;
                // delete this.searchData.gender;
            } catch (err) {
                console.log(err);
            }
        },
        // 同步
        async toSync() {
            try {
                const res = await api.postContactSync();
                if (res.code !== 0) return;
                this.$message.success('开始同步，稍后请手动刷新页面');
            } catch (err) {
                console.log(err);
            }
        },
        // 弹框
        toOpenContacts() {
            this.$refs.contacts.open();
        },
        toOpenTags() {
            this.$refs.tags.open();
        },
        // 操作
        tableChange(e) {
            this.searchData.page = e;
            this.search();
            this.checkAllStatus();
        },
        contactNameChange(e) {
            if (e.target.value) {
                if (this.selectType === '2') this.searchData.contactName = e.target.value;
                else this.searchData.keyWords = e.target.value;
            } else {
                if (this.selectType === '2') delete this.searchData.contactName;
                else delete this.searchData.keyWords;
                this.search();
            }
        },
        dateTimeChange(date, dateString) {
            if (_.compact(dateString).length > 0) {
                this.searchData.startTime = dateString[0];
                this.searchData.endTime = dateString[1];
            } else {
                delete this.searchData.startTime;
                delete this.searchData.endTime;
                this.search();
            }
        },
        contactsChange(e) {
            if (e) {
                this.searchData.userId = e;
            } else {
                delete this.searchData.userId;
                this.search();
            }
        },
        tagsChange(e) {
            if (e) {
                this.tagSelect = e.map((item) => {
                    const row = item;
                    row.tagId = item.key;
                    row.tagName = item.label;
                    return row;
                });
                this.tagsValue = e.map((item) => {
                    return { key: item.key };
                });
                this.searchData.tagId = _.map(e, 'tagId');
            } else {
                delete this.searchData.tagId;
                this.search();
            }
        },
        // 打开
        toOpen() {
            if (this.currCustomer.length === 0) return this.$message.error('请先选择客户');
            this.$refs.customerDrawer.open();
        },
        // 筛选当前客户
        selectCustomer(selected, selectedArr) {
            if (selected) {
                this.currCustomer = _.concat(this.currCustomer, selectedArr);
            } else {
                let newArr = [];
                // 去重
                this.currCustomer.forEach((item) => {
                    let arrFlag = false;
                    selectedArr.forEach((cur) => {
                        if (cur.id === item.id) {
                            arrFlag = true;
                        }
                    });
                    if (!arrFlag) newArr.push(item);
                });
                this.currCustomer = newArr;
            }
        },
        backStatus(data) {
            if (data) {
                this.search();
                this.currCustomer = [];
                this.rowSelection.selectedRowKeys = [];
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        onCheckAllChange(e) {
            let selecedKey = this.rowSelection.selectedRowKeys;
            if (this.rowSelection.selectedRowKeys.length < this.pagination.total) {
                if (this.currCustomer.length < this.dataList.length) {
                    if (this.currCustomer.length > 0) this.currCustomer =  _.concat(this.currCustomer, _.differenceBy(this.dataList, this.currCustomer, 'id'));
                    else this.currCustomer =  _.differenceBy(this.dataList, this.currCustomer, 'id');
                } else {
                    if (this.currCustomer.length > 0) this.currCustomer =  _.concat(this.currCustomer, _.differenceBy(this.dataList, this.currCustomer, 'id'));
                    else this.currCustomer =  _.differenceBy(this.currCustomer, this.dataList, 'id');
                }
                if (this.currCustomer.length === 0) {
                    selecedKey = [];
                    this.rowSelection.onChange(selecedKey, this.dataList);
                    this.indeterminate = false;
                    this.checkAll = false;
                } else if (this.currCustomer.length === this.pagination.total) {
                    this.indeterminate = false;
                    this.checkAll = true;
                } else {
                    this.indeterminate = true;
                    this.checkAll = false;
                }
                selecedKey = _.map(this.currCustomer, 'id');
                this.rowSelection.onChange(selecedKey, this.currCustomer);
            } else {
                selecedKey = [];
                this.rowSelection.onChange(selecedKey, this.dataList);
                this.currCustomer = [];
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        // 判断底部全选按钮状态
        checkAllStatus() {
            if (this.rowSelection.selectedRowKeys.length < this.pagination.total) {
                this.indeterminate = this.currCustomer.length === 0 ? false : true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = true;
            }
        },
        // 选择
        changeSelect(e) {
            if (e === '1' || e === '3') {
                delete this.searchData.contactName;
            } else {
                delete this.searchData.keyWords;
            }
        },
        checkboxChange(e) {
            if (e.length === 0 || e.length === 2) {
                delete this.searchData.gender;
            } else if (e.length === 1) {
                e.forEach(item => {
                    if (item === '男性') this.searchData.gender = 1;
                    else this.searchData.gender = 2;
                })
            }
        },
        condition() {
            let arr = [];
            Object.keys(this.searchData).forEach(key => {
                if (key !== 'page') {
                    arr.push({
                        name: key,
                        value: key === 'gender' ? (this.searchData[key] === 1 ? '男性' : '女性') : ((key === "userId" || key === "tagId") ? this.searchData[key].length : (key === "selectType" ? (this.searchData[key] === '2' ? '微信' : (this.searchData[key] === '3' ? '企业微信' : '全部')) : this.searchData[key])),
                        newName: key === 'gender' ? '性别' : ((key === 'keyWords' || key === 'contactName') ? '搜索词' : (key === 'userId' ? '成员' : (key === 'tagId' ? '标签' : (key === 'startTime' ? '开始日期' : (key === 'selectType' ? '来源' : '截止日期')))))
                    })
                }
            });
            this.currCondition = arr;
        },
        tagClose(data) {
            let arr = [];
            this.currCondition.forEach(item => {
                if (data.name !== item.name) arr.push(item);
            });
            if (data.name !== "userId" && data.name !== "tagId") {
                delete this.searchData[data.name];
                if (data.name === "startTime") this.dateTime = this.dateTime.length > 1 ? [this.dateTime[1]] : [];
                if (data.name === "endTime") this.dateTime = this.dateTime.length > 1 ? [this.dateTime[0]] : [];
            }
            else {
                this.searchData[data.name] = [];
                if (data.name == "tagId") this.tagsValue = [];
            }
            this.currCondition = arr;
        }
    }
};
</script>

<style>
#customer .ant-table-body {
    max-height: calc(100vh - 370px) !important;
    overflow-y: auto !important;
}
#customer .active_bg .ant-table-body {
    max-height: calc(100vh - 320px) !important;
    overflow-y: auto !important;
}
#customer .ant-table-footer {
    background: none; 
}
</style>